module.exports = __webpack_public_path__ + "img/201609-1 (1).0e0228f2.jpg";